// extracted by mini-css-extract-plugin
export default {"image":"style_image__x0XJ4","imageWrap":"style_imageWrap__j0Juq"};